export default __webpack_public_path__ + "static/media/drishti_white.32ced8b0.webp";